var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 1.75H2.35714C1.48927 1.75 0.785715 2.45355 0.785715 3.32143V12.75C0.785715 13.6179 1.48927 14.3214 2.35714 14.3214H15.7143C16.5822 14.3214 17.2857 13.6179 17.2857 12.75V3.32143C17.2857 2.45355 16.5822 1.75 15.7143 1.75Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03571 10.3929C10.3375 10.3929 11.3929 9.33753 11.3929 8.03572C11.3929 6.7339 10.3375 5.67857 9.03571 5.67857C7.7339 5.67857 6.67857 6.7339 6.67857 8.03572C6.67857 9.33753 7.7339 10.3929 9.03571 10.3929Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.25H19.6429C20.0596 18.25 20.4593 18.0844 20.754 17.7897C21.0487 17.495 21.2143 17.0953 21.2143 16.6786V8.82143",
    stroke: "#F8F8F8",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBilling);
export default __webpack_public_path__ + "static/media/icon-billing.af5d41f6f825490ec73d7f77114361ae.svg";
export { ForwardRef as ReactComponent };